<!-- Large and Medium screens -->
<div *ngIf="!isMobile" class="vw-grid">
  <div *ngIf="!isStarted" class="inspiration-start">
    <div class="inspiration-start__content">
      <img class="inspiration-start__logo" src="assets/logos/logo_home.png" />
      <div class="inspiration-start__title">Suggestions de balade</div>
      <div class="inspiration-start__description">
        Partez à la découverte du Val d'Oise et trouvez votre balade
      </div>
      <button
        class="filter-button"
        mat-raised-button
        (click)="start()"
        color="accent"
        matBadgeSize="large"
        matBadgePosition="after"
      >
        <mat-icon class="custom-icon" svgIcon="inspiration"></mat-icon>
        Commencer
      </button>
    </div>
  </div>
  <div *ngIf="isStarted" class="vw-inspiration__container">
    <div class="vw-inspiration__header">
      <mat-toolbar-row class="navbar__row">
        <button
          mat-icon-button
          color="black"
          aria-label="Example icon button with a heart icon"
        >
          <a
            routerLink="/carte"
            mat-icon-button
            disableRipple="true"
            aria-label="Vers inspiration"
            >X</a
          >
        </button>
        <h1 class="vw-inspiration__title">
          {{ 'InspirationTitle' | translate }}
        </h1>
      </mat-toolbar-row>
    </div>
    <form (submit)="handleSubmit($event)" class="vw-inspiration__body">
      <i class="vw-inspiration__subtitle">{{
        'InspirationSubTitle' | translate
      }}</i>
      <div style="height: 20px"></div>
      <div class="vw-inspiration__box">
        <div style="height: 15px"></div>
        <i class="vw-inspiration__questionlabel"
          >{{ 'InspirationQuestionLabel' | translate }} {{ step + 1 }}/3</i
        >
        <div *ngIf="form">
          <div *ngFor="let question of form.questionData; let i = index">
            <div *ngIf="step == i">
              <h3 class="vw-inspiration__questiontitle">
                {{ question.questionTitle }}
              </h3>
              <div class="form-group">
                <section class="form-checkbox">
                  <div
                    class="vw-inspiration__question__option"
                    *ngFor="let option of question.responses; let j = index"
                  >
                    <input
                      [id]="option.responseIdentificator"
                      type="radio"
                      [name]="option.responseIdentificator"
                      [value]="option"
                      [checked]="
                        option.responseIdentificator ===
                        results[i]?.responseIdentificator
                      "
                      (click)="results[i] = option"
                    />
                    <label [for]="option.responseIdentificator">{{
                      option.responseTitle
                    }}</label>
                  </div>
                  <p></p>
                </section>

                <span
                  style="color: red"
                  class="text-danger"
                  *ngIf="stateForm && !results[i]"
                  >Veuillez selectionner au moins un élément.
                </span>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div style="height: 100px"></div>
      </div>
      <div style="height: 20px"></div>
      <div class="form-button">
        <button
          style="float: left"
          *ngIf="step >= 1"
          (click)="previous()"
          mat-icon-button
        >
          <mat-icon>arrow_back_ios_new</mat-icon>
        </button>
        <div class="pager">
          <div *ngFor="let i of [0, 1, 2]">
            <div
              class="dot"
              [ngClass]="step == i ? 'selected' : 'unselected'"
            ></div>
          </div>
        </div>
        <button
          style="float: right"
          *ngIf="step != 2"
          (click)="next(true)"
          mat-icon-button
        >
          <mat-icon>arrow_forward_ios_new</mat-icon>
        </button>
        <button
          *ngIf="step == 2"
          class="mat-button mat-raised-button mat-accent submit-button"
          type="submit"
        >
          {{ 'InspirationSubmitButton' | translate }}
        </button>
        <button
          *ngIf="step == 1"
          (click)="next(false)"
          class="mat-button mat-raised-button mat-skip"
        >
          {{ 'InspirationSkip' | translate }}
        </button>
        <button
          *ngIf="step == 2"
          (click)="next(false)"
          class="mat-button mat-raised-button mat-skip"
        >
          {{ 'InspirationSkip' | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="vw-result__container">
    <mat-toolbar class="navbar {{ 'navbar-margin' }}">
      <mat-toolbar-row class="navbar__row inspiration-form"> </mat-toolbar-row>
      <mat-toolbar-row class="navbar__row">
        <span style="padding: 0 10px">
          <span class="result-nb">{{ '0' }}</span>
          <span class="centered result-p" translate="">Suggestions</span>
        </span>
        <mat-divider fxFlex=""></mat-divider>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
</div>

<!-- Mobile screens -->
<div *ngIf="isMobile" class="mobile-vw-grid">
  <div *ngIf="!isStarted" class="mobile-inspiration-start">
    <div class="inspiration-start__content">
      <img class="inspiration-start__logo" src="assets/logos/logo_home.png" />
      <div class="inspiration-start__title">Suggestions de balade</div>
      <div class="inspiration-start__description">
        Partez à la découverte du Val d'Oise et trouvez votre balade
      </div>
      <button
        class="filter-button"
        mat-raised-button
        (click)="start()"
        color="accent"
        matBadgeSize="large"
        matBadgePosition="after"
      >
        <mat-icon class="custom-icon" svgIcon="inspiration"></mat-icon>
        Commencer
      </button>
    </div>
  </div>
  <div *ngIf="isStarted" class="mobile-vw-inspiration__container">
    <div class="vw-inspiration__header">
      <mat-toolbar-row class="navbar__row">
        <button
          mat-icon-button
          color="black"
          aria-label="Example icon button with a heart icon"
        >
          <a
            routerLink="/carte"
            mat-icon-button
            disableRipple="true"
            aria-label="Vers inspiration"
            >X</a
          >
        </button>
        <h1 class="vw-inspiration__title">
          {{ 'InspirationTitle' | translate }}
        </h1>
      </mat-toolbar-row>
    </div>
    <form (submit)="handleSubmit($event)" class="vw-inspiration__body">
      <i class="vw-inspiration__subtitle">{{
        'InspirationSubTitle' | translate
      }}</i>
      <div style="height: 20px"></div>
      <div class="vw-inspiration__box">
        <div style="height: 15px"></div>
        <i class="vw-inspiration__questionlabel"
          >{{ 'InspirationQuestionLabel' | translate }} {{ step + 1 }}/3</i
        >
        <div *ngIf="form">
          <div *ngFor="let question of form.questionData; let i = index">
            <div *ngIf="step == i">
              <h3 class="vw-inspiration__questiontitle">
                {{ question.questionTitle }}
              </h3>
              <div class="form-group">
                <section class="form-checkbox">
                  <div
                    class="vw-inspiration__question__option"
                    *ngFor="let option of question.responses; let j = index"
                  >
                    <input
                      [id]="option.responseIdentificator"
                      type="radio"
                      [name]="option.responseIdentificator"
                      [value]="option"
                      [checked]="
                        option.responseIdentificator ===
                        results[i]?.responseIdentificator
                      "
                      (click)="results[i] = option"
                    />
                    <label [for]="option.responseIdentificator">{{
                      option.responseTitle
                    }}</label>
                  </div>
                  <p></p>
                </section>

                <span
                  style="color: red"
                  class="text-danger"
                  *ngIf="stateForm && !results[i]"
                  >Veuillez selectionner au moins un élément.
                </span>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div style="height: 100px"></div>
      </div>
      <div style="height: 20px"></div>
      <div class="form-button">
        <button
          style="float: left"
          *ngIf="step >= 1"
          (click)="previous()"
          mat-icon-button
        >
          <mat-icon>arrow_back_ios_new</mat-icon>
        </button>
        <div class="pager">
          <div *ngFor="let i of [0, 1, 2]">
            <div
              class="dot"
              [ngClass]="step == i ? 'selected' : 'unselected'"
            ></div>
          </div>
        </div>
        <button
          style="float: right"
          *ngIf="step != 2"
          (click)="next(true)"
          mat-icon-button
        >
          <mat-icon>arrow_forward_ios_new</mat-icon>
        </button>
        <button
          *ngIf="step == 2"
          class="mat-button mat-raised-button mat-accent submit-button"
          type="submit"
        >
          {{ 'InspirationSubmitButton' | translate }}
        </button>
        <button
          *ngIf="step == 1"
          (click)="next(false)"
          class="mat-button mat-raised-button mat-skip"
        >
          {{ 'InspirationSkip' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
